import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IRuleGroupElement } from "./RuleGroupElement";

export interface TRuleGroup {
  id: number;
  name: string;
  description: string;
  weightThreshold: number;
}

export interface IRuleGroup extends TRuleGroup {
  elements: IRuleGroupElement[];
  ruleGroupElements: IRuleGroupElement[];
}

const RuleGroup = Model(
  (model: TRuleGroup): IRuleGroup => {
    const _ruleGroup: TRuleGroup = Object.assign({}, model);
    let _elements: IRuleGroupElement[] = [];
    let _ruleGroupElements: IRuleGroupElement[] = [];
    let create = (ruleGroup: IRuleGroup): IRuleGroup => {
      let obj = ValidatableObject(ruleGroup);
      return obj;
    };

    let ruleGroup = {
      get id() {
        return _ruleGroup.id;
      },
      set id(value) {
        _ruleGroup.id = value;
      },
      get name() {
        return _ruleGroup.name;
      },
      set name(value) {
        _ruleGroup.name = value;
      },
      get description() {
        return _ruleGroup.description;
      },
      set description(value) {
        _ruleGroup.description = value;
      },
      get weightThreshold() {
        return _ruleGroup.weightThreshold;
      },
      set weightThreshold(value) {
        _ruleGroup.weightThreshold = value;
      },
      get elements() {
        return _elements;
      },
      set elements(value) {
        _elements = value;
      },
      get ruleGroupElements() {
        return _ruleGroupElements;
      },
      set ruleGroupElements(value) {
        _ruleGroupElements = value;
      }
    };

    return create(ruleGroup);
  }
);

export default RuleGroup;
